
// // import React, { useState, useEffect, useRef } from "react";

// // import PrimiumTable from "../TableManagment/PrimiumTable";
// // import { Link } from "react-router-dom";
// // const Foodtablemanagment = ({ plan }) => {
// //     const subscriptionPlan = plan || localStorage.getItem("planType") || "premium"; <PrimiumTable />
// //     const isMobile = window.innerWidth <= 768;



// //     const renderComponentByPlan = () => {
// //         switch (subscriptionPlan.toLowerCase()) {
// //             case "basic":
// //                 return <PrimiumTable />;
// //             case "standard":
// //                 return <PrimiumTable />;
// //             // <Tablereservation />
// //             case "premium":
// //                 return <PrimiumTable />;
// //             default:
// //                 return <div>Invalid plan selected</div>;
// //         }
// //     };

// //     return (
// //         <div className="container-fluid">
// //             <div className="row">
// //                 {/* Left margin or sidebar */}
// //                 <div className="col-lg-2"></div>

// //                 {/* Main content area (component displayed here) */}
// //                 <div className="col-lg-10" style={{ marginTop: "130px" }}>
// //                     <p
// //                         className="breadcrumb maamaas-home-bredcum"
// //                         style={{
// //                             position: "fixed",
// //                                 top: window.innerWidth <= 430 ? "50px" : window.innerWidth > 430 && window.innerWidth <= 768 ? "55px" : "64px" ,                            
// //                             left: "2vw",
// //                             width: "100%",
// //                             backgroundColor: "#fff",
// //                             zIndex: 100,
// //                             padding: "10px 0",
// //                             fontSize: isMobile ? "16px" : "18px",
// //                             fontWeight: isMobile ? "normal" : "bold",
// //                             textAlign: "center",
// //                             margin: 0,
// //                         }}
// //                     >
// //                         {/* <Link
// //                             to="/Newmainlandingpage"
// //                             style={{
// //                                 color: "purple",
// //                                 fontWeight: "bold",
// //                                 textDecoration: "none",
// //                             }}
// //                         >
// //                             Home
// //                         </Link> */}
// //                         {/* <span className="separator"> &gt; </span> */}
// //                         <Link
// //                             to="/fooddashboard"
// //                             style={{
// //                                 color: "purple",
// //                                 fontWeight: "bold",
// //                                 textDecoration: "none",
// //                             }}
// //                         >
// //                             Food & Beverages
// //                         </Link>
// //                         <span className="separator"> &gt; </span>
// //                         <Link

// //                             style={{
// //                                 color: "purple",
// //                                 fontWeight: "bold",
// //                                 textDecoration: "none",
// //                             }}
// //                         >
// //                             Table Management
// //                         </Link>

// //                     </p>
// //                     {renderComponentByPlan()}
// //                 </div>

// //                 {/* Optional right-side content or spacing */}
// //                 {/* <div className="col-lg-3"></div> */}

// //             </div>
// //         </div>
// //     );
// // };

// // export default Foodtablemanagment;





// import React, { useState, useEffect, useRef } from "react";
// import PrimiumTable from "../TableManagment/PrimiumTable";
// import { Link } from "react-router-dom";

// const Foodtablemanagment = ({ plan }) => {
//     const subscriptionPlan = plan || localStorage.getItem("planType") || "premium";
//     const [isMobile, setIsMobile] = useState(false);
//     const [windowWidth, setWindowWidth] = useState(0);

//     // Handle responsive window size
//     useEffect(() => {
//         const handleResize = () => {
//             const width = window.innerWidth;
//             setWindowWidth(width);
//             setIsMobile(width <= 768);
//         };

//         // Set initial values
//         handleResize();

//         // Add event listener
//         window.addEventListener('resize', handleResize);

//         // Cleanup
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     const renderComponentByPlan = () => {
//         switch (subscriptionPlan.toLowerCase()) {
//             case "basic":
//                 return <PrimiumTable />;
//             case "standard":
//                 return <PrimiumTable />;
//             case "premium":
//                 return <PrimiumTable />;
//             default:
//                 return <div>Invalid plan selected</div>;
//         }
//     };



//     return (
//         <div className="container-fluid px-0">
//              <style>
//                 {`
//                 @media screen and (max-width: 768px) {
//     .row {
//         margin-top: 50px !important;
//     }
// }
//                 `}
//             </style>
//             <div className="row mx-0">
//                 {/* Responsive layout - hide sidebar on small screens */}
//                 <div className="col-lg-2 d-none d-lg-block"></div>

//                 {/* Main content area */}
//                 <div className="col-12 col-lg-10" style={{
//                     marginTop: windowWidth <= 768 ? "00px" : "30px",
//                     paddingLeft: windowWidth <= 768 ? "15px" : "",
//                     paddingRight: windowWidth <= 768 ? "15px" : ""
//                 }}>
//                     {/* Fixed Breadcrumb - Improved for mobile */}
//                     <p
//                         className="breadcrumb maamaas-home-bredcum"
//                         style={{
//                             position: "fixed",
//                             top: window.innerWidth <= 430 ? "50px" : window.innerWidth > 430 && window.innerWidth <= 768 ? "55px" : "64px",
//                             left: "2vw",
//                             width: "100%",
//                             backgroundColor: "#fff",
//                             zIndex: 100,
//                             padding: "10px 0",
//                             fontSize: isMobile ? "16px" : "18px",
//                             fontWeight: isMobile ? "normal" : "bold",
//                             textAlign: "center",
//                             margin: 0,
//                         }}
//                     >

//                         <Link
//                             to="/fooddashboard"
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             Food & Beverages
//                         </Link>
//                         <span className="separator"> &gt; </span>
//                         <Link

//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             Table Management
//                         </Link>

//                     </p>

//                     {/* Main Content */}
//                     <div className="mt-4">
//                         {renderComponentByPlan()}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Foodtablemanagment;




import React, { useState, useEffect } from "react";
import PrimiumTable from "../TableManagment/PrimiumTable";
import { Link } from "react-router-dom";

const Foodtablemanagment = ({ plan }) => {
    const subscriptionPlan = plan || localStorage.getItem("planType") || "premium";
    const [isMobile, setIsMobile] = useState(false);
    const [windowWidth, setWindowWidth] = useState(0);

    // Handle responsive window size
    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setWindowWidth(width);
            setIsMobile(width <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const renderComponentByPlan = () => {
        switch (subscriptionPlan.toLowerCase()) {
            case "basic":
                return <PrimiumTable />;
            case "standard":
                return <PrimiumTable />;
            case "premium":
                return <PrimiumTable />;
            default:
                return <div>Invalid plan selected</div>;
        }
    };

    // Calculate breadcrumb top position
    const getBreadcrumbTop = () => {
        if (windowWidth <= 430) return "50px";
        if (windowWidth <= 768) return "55px";
        return "64px";
    };

    // Calculate breadcrumb padding
    const getBreadcrumbPadding = () => {
        if (windowWidth <= 430) return "8px 0";
        if (windowWidth <= 768) return "10px 0";
        return "12px 0";
    };

    return (
        <div className="container-fluid px-0">
            <style>{`
                @media screen and (max-width: 768px) {
                    .main-content-area {
                        margin-top: 00px !important;
                    }
                    .breadcrumb-fixed {
                        box-shadow: 0 2px 5px rgba(0,0,0,0.1);
                        border-bottom: 1px solid #eee;
                    }
                }
            `}</style>
            <div className="row">

                <div className="col-lg-2"></div>

                <div className="col-lg-10 row mx-0">
                    {/* Breadcrumb - Fixed at top */}
                    <p
                        className="breadcrumb maamaas-home-bredcum"
                        style={{
                            position: "fixed",
                            top: window.innerWidth <= 430 ? "50px" : window.innerWidth > 430 && window.innerWidth <= 768 ? "55px" : "64px",
                            left: "2vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: 100,
                            padding: "10px 0",
                            fontSize: isMobile ? "16px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >

                        <Link
                            to="/fooddashboard"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Food & Beverages
                        </Link>
                        <span className="separator"> &gt; </span>
                        <Link

                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Table Management
                        </Link>

                    </p>

                    {/* Main content area */}
                    <div className="col-12 main-content-area" style={{
                        marginTop: windowWidth <= 768 ? "0px" : "130px",
                        padding: windowWidth <= 768 ? "0 15px" : "0 20px 0 0px"
                    }}>
                        {renderComponentByPlan()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Foodtablemanagment;